/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Location Type
 *
 * "Nearby" is a location where you return to the reporting site at EOD
 * "Distant" is a location that requires an overnight stay
 */
export enum LocationType {
    Studio = 'Studio',
    Nearby = 'Nearby',
    Distant = 'Distant',
    Airport = 'Airport',
}
